import { v4 as uuid4 } from 'uuid'

import { IForm } from 'core-components/classes/models/IForm'
import { AFLogic, AFOperator } from 'core-components/types'
import { defaultFilterValue } from 'src/core/components/shared/ui/audienceFilter/constants'
import { IGroup } from 'src/core/components/shared/ui/audienceFilter/GroupWrapper'

export function allowed(userRoles: string[], checkRoles: string[]) {
  return userRoles.some((firstArrItem) =>
    checkRoles.find((secondArrItem) => firstArrItem === secondArrItem)
  )
}

export const defaultGroup: IGroup = {
  isGroup: true,
  operator: AFLogic.AND,
  elements: [],
  id: 'Root',
}

const formGroups = (arr: string[]): IGroup => {
  const parsedByOperators = arr.map((el) => {
    const match = el.match(/AND|OR/)
    const operator = match ? match[0] : ''
    const isRootGroup = !el.match(/\(.+\)/)
    return { operator: operator, group: el, id: isRootGroup ? 'Root' : uuid4() }
  })

  const result = parsedByOperators.reduce((acc: any, cur: IForm) => {
    const elements = cur.group.split(/AND|OR/).map((el: string) => {
      const newEl = el.replace(/\(|\)/g, '')
      const isCalculatedGroup = newEl.trim().match(/\$replaceIndex_\%\d+/)

      if (isCalculatedGroup) {
        const index = Number(isCalculatedGroup[0].replace(/\(|\)|\%|\$replaceIndex_/g, ''))
        return acc[index]
      }
      const values = Object.values(AFOperator).sort((a, b) => b.length - a.length)
      const condition = values.find((item) => newEl.trim().includes(item))
      const data = condition ? newEl.trim().split(condition) : null
      return {
        id: uuid4(),
        field: data ? data[0].trim() : '',
        condition: condition || '',
        value: data
          ? data[1]
              .trim()
              .replace(/\'/g, '')
              .replace(/^\%+|\%+$/g, '')
          : '',
      }
    })
    const obj = {
      isGroup: true,
      operator: cur.operator || AFLogic.AND,
      elements: elements,
      id: cur.id,
    }
    return [...acc, obj]
  }, [])
  return result.slice(-1)[0]
}

const separateByGroups = (str: string, arr: string[]) => {
  if (str === defaultFilterValue) {
    return []
  }
  if (!str.match(/\(([^()]+)\)/g)) {
    arr.push(str)
    return arr
  }

  const preparedValue = str.replace(/\(\'|\'\)/g, "'")
  const needFixGroup = isGroupBroken(preparedValue)
  let newStr = needFixGroup ? str : preparedValue
  const matched = newStr.match(/\(([^()]+)\)/g) || []
  matched.forEach((el: string) => {
    arr.push(el)
    newStr = newStr.replace(el, `$replaceIndex_%${arr.length - 1}`)
  })
  separateByGroups(newStr, arr)
  return arr
}

// replace  str.replace(/\(\'|\'\)/g, "'") broke string with groups
// for example FIELD = 1 and (FIELD = 2 or FIELD = 3) => FIELD = 1 and (FIELD = 2 or FIELD = 3
// we must remove this replacing or fix this.
const isGroupBroken = (str: string) => {
  let openCharCount = 0
  let closeCharCount = 0
  for (let i = 0; i < str.length; i++) {
    if (str[i] === '(') {
      openCharCount++
    } else if (str[i] === ')') {
      closeCharCount++
    }
  }
  return openCharCount !== closeCharCount
}

export const parseStringToGroups = (stringFilter: string): IGroup => {
  const rules = separateByGroups(stringFilter, [])

  if (rules && rules.length) {
    return formGroups(rules)
  }

  return defaultGroup
}

export const parseAudienceFilter = (str: string) => {
  const group = parseStringToGroups(str)

  return group.elements
}

export const parseGroupsToString = (group: IGroup) => {
  const arr: string[] = []
  group.elements.forEach((el) => {
    if (el['isGroup']) {
      arr.push(parseGroupsToString(el as IGroup))
    } else {
      let value = `'${el['value']}'`
      if (el['condition'] === AFOperator.LIKE || el['condition'] === AFOperator.NOT_LIKE) {
        value = `('%${el['value']}%')`
      }
      if (el['condition'] === AFOperator.IN || el['condition'] === AFOperator.NOT_IN) {
        value = `(${el['value']
          .split(', ')
          .map((valueEl: string) => `'${valueEl}'`)
          .join(', ')})`
      }
      const isConditionFullFilled = el['value'] && el['condition'] && el['field']
      if (isConditionFullFilled) {
        arr.push(el['field'] + ' ' + el['condition'] + ' ' + value)
      }
    }
  })
  if (group.id === 'Root') {
    return arr.length ? arr.join(` ${group.operator} `) : ''
  }
  return arr.length ? '(' + arr.join(` ${group.operator} `) + ')' : ''
}
